import Breadcrumb from '@/components/base/Breadcrumb';

export default function AboutPage() {
  return (
    <main className="flex-1">
      <section className="relative w-full h-56 md:h-72 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Travel%20planning%20workspace%20with%20world%20map%20on%20wooden%20table%20vintage%20compass%20travel%20journal%20camera%20warm%20natural%20light%20from%20window%20cozy%20atmosphere&width=1600&height=600&seq=about-hero-banner&orientation=landscape"
          alt="关于亚洲天堂"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-white mb-2">关于亚洲天堂</h1>
          <p className="text-sm md:text-base text-white/80 max-w-lg">汇聚亚洲之美，点亮您的旅行灵感</p>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-6 md:py-8">
        <div className="max-w-4xl mx-auto">
          <Breadcrumb items={[
            { label: '首页', to: '/' },
            { label: '关于我们' },
          ]} />
        </div>
      </section>

      <section className="w-full px-4 md:px-6 pb-10 md:pb-14">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
              品牌故事
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                亚洲天堂创立于2018年，由一群热爱亚洲旅行的资深旅行者共同打造。我们的足迹遍布亚洲30多个国家和地区，从喜马拉雅山麓到印度洋珊瑚礁，从千年古都到繁华都市，我们用亲身经历为您甄选亚洲最美的旅行目的地。
              </p>
              <p>
                我们相信，旅行不仅是从一个地方到另一个地方的移动，更是一种探索世界、发现自我的方式。亚洲天堂致力于为每一位旅行者提供最真实、最全面、最有温度的旅行攻略与灵感。
              </p>
              <p>
                六年来，我们已经帮助超过200万旅行者规划了他们的亚洲之旅。从第一次出国的新手到经验丰富的环球旅行家，亚洲天堂始终是您探索亚洲最值得信赖的伙伴。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-12">
            {[
              { number: '200万+', label: '服务旅友' },
              { number: '30+', label: '覆盖国家' },
              { number: '5000+', label: '攻略文章' },
              { number: '98%', label: '好评率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center p-4 md:p-6 bg-background-50 rounded-lg border border-background-200/70">
                <div className="font-heading text-xl md:text-3xl font-bold text-primary-500 mb-1">
                  {stat.number}
                </div>
                <div className="text-xs md:text-sm text-foreground-600">{stat.label}</div>
              </div>
            ))}
          </div>

          <div className="mb-12">
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0 mt-0.5">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-600">contact@rstuwlw.cn</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0 mt-0.5">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">联系电话</h3>
                    <p className="text-sm text-foreground-600">+86 400-888-9999</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-800 mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-600">上海市浦东新区陆家嘴金融贸易区世纪大道100号</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-4">发送消息</h3>
                <form
                  data-readdy-form
                  className="flex flex-col gap-3"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const formData = new FormData(form);
                    const honeypot = (formData.get('phone_alt') as string || '').trim();
                    if (honeypot) {
                      alert('消息已发送！');
                      form.reset();
                      return;
                    }
                    const payload = new URLSearchParams();
                    payload.append('name', formData.get('name') as string);
                    payload.append('email', formData.get('email') as string);
                    payload.append('message', formData.get('message') as string);
                    try {
                      const res = await fetch('https://readdy.ai/api/form/d9tvl1v8l97n3eas3eh0', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: payload.toString(),
                      });
                      const responseText = await res.text();
                      let parsed;
                      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                      if (res.ok && parsed?.code === 'OK') {
                        alert('消息已发送，我们会尽快回复！');
                        form.reset();
                      } else {
                        const serverMsg = parsed?.meta?.message || parsed?.message || '发送失败，请稍后再试';
                        alert(serverMsg);
                      }
                    } catch {
                      alert('网络错误，请检查您的网络连接后重试');
                    }
                  }}
                >
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    readOnly
                    aria-hidden="true"
                    className="spam-guard"
                  />
                  <input
                    type="text"
                    name="name"
                    placeholder="您的姓名"
                    required
                    className="px-3 py-2 text-sm rounded-md border border-background-200 focus:outline-none focus:border-primary-400 bg-white transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="您的邮箱"
                    required
                    className="px-3 py-2 text-sm rounded-md border border-background-200 focus:outline-none focus:border-primary-400 bg-white transition-colors"
                  />
                  <textarea
                    name="message"
                    placeholder="请输入您的消息（最多500字）"
                    rows={4}
                    maxLength={500}
                    required
                    className="px-3 py-2 text-sm rounded-md border border-background-200 focus:outline-none focus:border-primary-400 bg-white transition-colors resize-none"
                  ></textarea>
                  <button
                    type="submit"
                    className="px-4 py-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap"
                  >
                    发送消息
                  </button>
                </form>
              </div>
            </div>
          </div>

          <div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-6">
              常见问题
            </h2>
            <div className="space-y-3">
              {[
                { q: '亚洲天堂的内容是否免费？', a: '是的，亚洲天堂的所有旅行攻略和文章内容完全免费开放，您可以随时浏览和阅读。' },
                { q: '如何获取最新的旅行攻略？', a: '您可以订阅我们的Newsletter，我们会每周推送最新的旅行攻略、特价机票和酒店优惠信息。' },
                { q: '是否可以投稿分享旅行经历？', a: '当然可以！我们欢迎每一位旅行爱好者分享您的独特经历。请通过联系表单发送您的稿件。' },
                { q: '攻略中的价格信息是否准确？', a: '我们会尽力确保信息的时效性，但机票、酒店等价格会随季节和市场波动，建议以实际预订为准。' },
              ].map((faq, idx) => (
                <details key={idx} className="bg-background-50 rounded-lg border border-background-200/70 group">
                  <summary className="px-5 py-3 md:py-4 text-sm md:text-base font-medium text-foreground-800 cursor-pointer hover:text-primary-600 transition-colors list-none flex items-center justify-between">
                    {faq.q}
                    <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-foreground-400"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </div>
      </section>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "亚洲天堂",
          "url": "https://rstuwlw.cn",
          "description": "亚洲天堂汇聚亚洲最令人心动的旅行胜地与度假体验，提供最全面的亚洲旅游攻略、目的地推荐与出行规划。",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+86-400-888-9999",
            "contactType": "customer service",
            "availableLanguage": ["Chinese"],
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "上海",
            "addressRegion": "浦东新区",
            "streetAddress": "陆家嘴金融贸易区世纪大道100号",
            "addressCountry": "CN",
          },
        })
      }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": "亚洲天堂的内容是否免费？", "acceptedAnswer": { "@type": "Answer", "text": "是的，亚洲天堂的所有旅行攻略和文章内容完全免费开放，您可以随时浏览和阅读。" } },
            { "@type": "Question", "name": "如何获取最新的旅行攻略？", "acceptedAnswer": { "@type": "Answer", "text": "您可以订阅我们的Newsletter，我们会每周推送最新的旅行攻略、特价机票和酒店优惠信息。" } },
            { "@type": "Question", "name": "是否可以投稿分享旅行经历？", "acceptedAnswer": { "@type": "Answer", "text": "当然可以！我们欢迎每一位旅行爱好者分享您的独特经历。请通过联系表单发送您的稿件。" } },
            { "@type": "Question", "name": "攻略中的价格信息是否准确？", "acceptedAnswer": { "@type": "Answer", "text": "我们会尽力确保信息的时效性，但机票、酒店等价格会随季节和市场波动，建议以实际预订为准。" } },
          ],
        })
      }} />
    </main>
  );
}